export const CHECKOUT_INSURANCE_COVERAGE = '/insurance-coverage';
export const CHECKOUT_MAX_MILEAGE = '/max-mileage';
export const CHECKOUT_ADDONS = '/addons';
